/** @jsx jsx */
/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import { jsx } from '@emotion/core'
import { textAlignRight } from './style.js'
import React from 'react'
import { useCalculator, } from './use-calculator'
import { isEmpty, fmt, showBondOrder, hideModal, cleanObject } from '../twd'
import { Header } from './bond-details/header'

export const BondDetails = () => {

    const { bondInfo, from_ } = useCalculator()

    if (isEmpty(bondInfo)) return null

    const issue = bondInfo.issue || {}
    const bestoffer = bondInfo.bestoffer || {}
    const bid = bestoffer.bid || {}
    const ask = bestoffer.ask || {}

    return <React.Fragment>
        <div className="row">
        <div className="col-md-12">
            <div
                className="h3 text-bold text-truncate"
                style={{marginBottom:'0px', maxWidth:'300px', display:'inline'}}
                dangerouslySetInnerHTML={{__html:issue.issue}}
            />
            <div className="text-bold" style={{display:'inline', paddingLeft:'5px'}}>{ issue.cusip }</div>
        </div>
        </div>

        <div className="row  vertical-offset-xs">
        <div className="col-md-12 text-muted">
            <div style={{fontWeight:500}} dangerouslySetInnerHTML={{__html:issue.warningText}} />
        </div>
        </div>

        <div className="row bond-details-row">
        <div className="col-md-9 col-xs-12 vertical-offset-sm">
            <Offer bid={bid} />
            <Offer ask={ask} />
        </div>
        <div className="col-md-3 col-xs-12 text-center vertical-offset-sm bond-details-buttons" css={textAlignRight}>
            <div style={{marginTop:'auto'}}>
            <OrderButton action="S" bondInfo={bondInfo} from={from_} />
            <OrderButton action="B" bondInfo={bondInfo} from={from_} />
            </div>
        </div>
        </div>

        <Header />
    </React.Fragment>
}


const Offer = ({ask, bid}) => {
    const obj = bid ? bid : ask

    if (!obj || !obj.id) return null

    const label = bid ? 'Current best bid:' : 'Current best offer:'
    return <React.Fragment>
        <div>
        <span className='text-bold' style={{paddingRight:'10px'}}>{label}</span>
        Price <span className='text-bold' style={{paddingRight:'10px'}}>{fmt.price3(obj.dispPrice)}</span>
        YTM/YTW <span className='text-bold' style={{paddingRight:'10px'}}>{fmt.ytw3(obj.ytm)}/{fmt.ytw3(obj.ytw)}</span>
        Quantity <span className='text-bold'>Min. {fmt.qty(obj.quantityMin)} - Max. {fmt.qty(obj.quantity)}</span>
        </div>
        </React.Fragment>
}

const OrderButton = ({action:action_, bondInfo, from}) => {
    if (!bondInfo) return null

    const label = action_==='S' ? 'Sell' : 'Buy'
    const action = action_ === 'S' && bondInfo.isHeld && bondInfo.hasBid ? 'S'
        : action_ === 'S' && bondInfo.isHeld && !bondInfo.hasBid ? 'W'
        : !bondInfo.canTrade ? ''
        : action_ === 'B' && bondInfo.isRestricted ? '-'
        : action_ === 'B' && bondInfo.hasAsk ? 'B'
        : action_ === 'B' && !bondInfo.hasAsk ? 'F'
        : ''

    if (action==='-') {
        return fmt.orderPhone({ style: {marginLeft:'20px' }})
    }

    if (!action) return null

    return <a href='#'
        type="button"
        className={'btn btn-xs btn-primary-outline text-bold'}
        style={{
            paddingLeft:'20px',
            paddingRight:'20px',
            marginLeft: '10px',
        }}
        onClick={() => {
            hideModal()
            showBondOrder(cleanObject({
                action,
                cusip: bondInfo.cusip,
                qty: action==='S' ? bondInfo.holdings[0].qty : null,
                from,
                ts: Date.now(),
            }))
        }}
        >{label}</a>
}
